import { defineMessages } from 'react-intl';

export default defineMessages({
  shareButtonTooltip: {
    id: 'widget.compact-view.components.action-bar.share-tooltip-button',
    defaultMessage: 'Share',
  },
  shareThisChannel: {
    id: 'widget.compact-view.components.action-bar.share-this-channel',
    defaultMessage: 'Share this Channel',
  },
  channelInfoTooltip: {
    id: 'widget.compact-view.components.action-bar.channel-info-tooltip',
    defaultMessage: 'Channel Info',
  },
  close: {
    id: 'widget.compact-view.components.action-bar.close',
    defaultMessage: 'Close',
  },
});



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/translations.js